import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';
import { useAutoUpdate } from '../hooks/useAutoUpdate';

export default function Layout() {
  const { user, loading } = useAuth();
  const location = useLocation();
  useAutoUpdate(); // Auto-detect new deployments and refresh

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Immersive full-width mode for Chat messages route (no sidebar, no padding)
  const immersive = location.pathname === '/chat/messages';
  if (immersive) {
    return (
      <div className="min-h-screen bg-gray-100" data-testid="main-layout">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100" data-testid="main-layout">
      <Sidebar />
      <NotificationBell />
      <main className="lg:ml-64 min-h-screen">
        <div className="p-3 pt-16 sm:p-6 sm:pt-16 lg:pt-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
